export const options = {
    aspectRatio: 3 / 2,
    scales: {
        x: {
            beginAtZero: true,
            grid: {
                color: "rgba(30, 33, 37, 1)"
            },
            ticks: {
                color: "rgba(255, 255, 255, 1)"
            }
        },
        y: {
            beginAtZero: true,
            grid: {
                color: "rgba(0, 0, 0, 0)"
            },
            ticks: {
                color: "rgba(255, 255, 255, 1)",
                callback: function (value, index, values) {
                    return value + " " + "años"
                }
            }
        },
    },
    layout: {
        padding: {
            left: 10,
            right: 10,
            top: 10,
            bottom: 10
        }
    },
    plugins: {
        legend: {
            display: false,
        },
        tooltip: {
            enabled: false,
        },
    },
    elements: {
        point: {
            radius: 0,
            hoverRadius: 0,
        },
    },
    animation: {
        duration: 0,
        easing: 'linear',
    },
};





